import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import Header from "./Header";
import { User } from "../types";

const Menu = () => {
  const user = useOutletContext<User | null>();

  return (
    <div
      className="container-fluid p-0"
      style={{ minHeight: "100vh", backgroundColor: "#f4f6f9" }}
    >
      <Header title="メニュー" />

      <div className="container" style={{ maxWidth: "800px" }}>
        {/* 通常メニュー */}
        <div className="row g-4 justify-content-center mt-4">
          {/* --- 業務報告登録 --- */}
          <div className="col-md-6">
            <Link to="/entry" className="text-decoration-none">
              {/* 背景は白、上に青い太線 (border-primary) を追加 */}
              <div className="card h-100 shadow-sm border-0 border-top border-4 border-primary menu-hover-effect">
                <div className="card-body p-4 text-center">
                  {/* アイコン: 薄い青背景 + 青文字 */}
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex p-3 mb-3 shadow-sm">
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">業務報告登録</h5>
                  <p className="card-text text-muted small">
                    日々の業務実績を登録します
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* --- 業務報告一覧 --- */}
          <div className="col-md-6">
            <Link to="/list" className="text-decoration-none">
              {/* 背景は白、上に緑の太線 (border-success) を追加 */}
              <div className="card h-100 shadow-sm border-0 border-top border-4 border-success menu-hover-effect">
                <div className="card-body p-4 text-center">
                  {/* アイコン: 薄い緑背景 + 緑文字 */}
                  <div className="bg-success bg-opacity-10 text-success rounded-circle d-inline-flex p-3 mb-3 shadow-sm">
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">業務報告一覧</h5>
                  <p className="card-text text-muted small">
                    過去の履歴確認や編集・削除を行います
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* 管理者専用メニュー */}
        {user?.is_admin && (
          <div className="mt-5">
            <h6 className="text-secondary fw-bold border-bottom pb-2 mb-3">
              <span className="me-2">🔒</span>管理者メニュー
            </h6>

            <div className="row g-4">
              <div className="col-md-12">
                {/* 管理者メニューもスタイルを合わせる（白背景 + 枠線なし） */}
                <div className="card shadow-sm border-0 menu-hover-effect">
                  <div className="card-body d-flex align-items-center p-4">
                    <div className="bg-secondary bg-opacity-10 rounded-circle p-3 me-3 text-secondary">
                      <svg
                        width="32"
                        height="32"
                        fill="currentColor"
                        className="bi bi-gear-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.86z" />
                      </svg>
                    </div>

                    <div className="flex-grow-1">
                      <h5 className="card-title fw-bold mb-1">
                        マスタ管理画面
                      </h5>
                      <p className="card-text text-muted small m-0">
                        ユーザー、プロジェクト、カテゴリの追加・編集を行います
                      </p>
                    </div>

                    <Link
                      to="/admin"
                      className="btn btn-outline-secondary rounded-pill px-4 fw-bold"
                    >
                      開く
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default Menu;
